import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_confort-concierge/artifacts/qrkok7lw_Untitled%20design%2811%29.png";

const Footer = () => {
  const cities = [
    { slug: 'fougeres', name: 'Fougères' },
    { slug: 'rennes', name: 'Rennes' },
    { slug: 'vitre', name: 'Vitré' },
    { slug: 'dol-de-bretagne', name: 'Dol-de-Bretagne' },
    { slug: 'pleine-fougeres', name: 'Pleine-Fougères' },
  ];

  return (
    <footer className="bg-[#0A0A0A] border-t border-[#262626]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/">
              <img 
                src={LOGO_URL} 
                alt="Confort Hôte" 
                className="h-14 w-auto mb-6"
              />
            </Link>
            <p className="text-[#A3A3A3] text-sm leading-relaxed mb-6">
              Pilotage de locations courte durée en Ille-et-Vilaine. 
              Performance, rentabilité, sérénité.
            </p>
            <div className="flex flex-col gap-3">
              <a 
                href="tel:0689224402" 
                className="flex items-center gap-3 text-[#C5A059] hover:text-[#D4AF37] transition-colors duration-300"
                data-testid="footer-phone"
              >
                <Phone className="w-4 h-4" />
                <span className="text-sm">06 89 22 44 02</span>
              </a>
              <a 
                href="mailto:contact@confort-hote.fr" 
                className="flex items-center gap-3 text-[#A3A3A3] hover:text-[#C5A059] transition-colors duration-300"
                data-testid="footer-email"
              >
                <Mail className="w-4 h-4" />
                <span className="text-sm">contact@confort-hote.fr</span>
              </a>
            </div>
          </div>

          {/* Navigation Column */}
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-[#C5A059] font-semibold mb-6">
              Navigation
            </p>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-[#A3A3A3] hover:text-[#C5A059] text-sm transition-colors duration-300">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/conciergerie" className="text-[#A3A3A3] hover:text-[#C5A059] text-sm transition-colors duration-300">
                  La Conciergerie
                </Link>
              </li>
              <li>
                <Link to="/reglementation-airbnb" className="text-[#A3A3A3] hover:text-[#C5A059] text-sm transition-colors duration-300">
                  Réglementation
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-[#A3A3A3] hover:text-[#C5A059] text-sm transition-colors duration-300">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Cities Column */}
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-[#C5A059] font-semibold mb-6">
              Nos zones
            </p>
            <ul className="space-y-3">
              {cities.map((city) => (
                <li key={city.slug}>
                  <Link 
                    to={`/conciergerie/${city.slug}`} 
                    className="text-[#A3A3A3] hover:text-[#C5A059] text-sm transition-colors duration-300"
                  >
                    Conciergerie {city.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* CTA Column */}
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-[#C5A059] font-semibold mb-6">
              Parlons de votre bien
            </p>
            <p className="text-[#A3A3A3] text-sm leading-relaxed mb-6">
              Obtenez une estimation gratuite du potentiel locatif de votre bien.
            </p>
            <Link
              to="/contact"
              className="inline-block bg-[#C5A059] text-black px-6 py-3 text-xs uppercase tracking-[0.15em] font-semibold hover:bg-[#D4AF37] transition-colors duration-300"
              data-testid="footer-cta"
            >
              Audit Gratuit
            </Link>
          </div>
        </div>

        {/* Partners Section */}
        <div className="mt-12 pt-8 border-t border-[#262626]">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
            <p className="text-xs uppercase tracking-[0.15em] text-[#A3A3A3]">
              Nos partenaires de confiance
            </p>
            <div className="flex flex-wrap items-center gap-6">
              <a 
                href="https://hostprotect.io" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#A3A3A3] hover:text-[#C5A059] text-sm transition-colors duration-300"
                title="Assurance location courte durée"
              >
                Hostprotect
              </a>
              <span className="text-[#262626]">•</span>
              <a 
                href="https://quozyli.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#A3A3A3] hover:text-[#C5A059] text-sm transition-colors duration-300"
                title="Linge hôtelier premium"
              >
                Quozyli
              </a>
              <span className="text-[#262626]">•</span>
              <a 
                href="https://gt-bnb.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#A3A3A3] hover:text-[#C5A059] text-sm transition-colors duration-300"
                title="Solutions techniques location courte durée"
              >
                GT-BNB
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-8 border-t border-[#262626]">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-[#A3A3A3] text-xs">
              © {new Date().getFullYear()} Confort Hôte. Tous droits réservés.
            </p>
            <div className="flex gap-6">
              <Link 
                to="/mentions-legales" 
                className="text-[#A3A3A3] hover:text-[#C5A059] text-xs transition-colors duration-300"
                data-testid="footer-legal"
              >
                Mentions légales
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
